import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { validate as uuidValidate } from 'uuid';

import { CrudMode } from 'types';

export const useCrudMode = (basePath?: string) => {
  const location = useLocation();

  return useMemo((): CrudMode => {
    const pathname = location.pathname;

    if (basePath) {
      // Extract the relevant part of the path after basePath
      const basePathNormalized = basePath.startsWith('/')
        ? basePath
        : `/${basePath}`;
      const baseIndex = pathname.indexOf(basePathNormalized);

      if (baseIndex === -1) {
        return CrudMode.LIST; // basePath not found in current route
      }

      // Get the path segment after basePath
      const relevantPath = pathname.substring(
        baseIndex + basePathNormalized.length
      );
      const segments = relevantPath.split('/').filter(Boolean);

      // Check patterns within the basePath context
      if (segments.length >= 2) {
        const [firstSegment, secondSegment] = segments;

        if (firstSegment === 'edit' && uuidValidate(secondSegment)) {
          return CrudMode.EDIT;
        }

        if (secondSegment === 'edit' && uuidValidate(firstSegment)) {
          return CrudMode.EDIT;
        }
      }

      if (segments.length >= 1 && segments[0] === 'new') {
        return CrudMode.NEW;
      }

      if (segments.length >= 1 && uuidValidate(segments[0])) {
        return CrudMode.VIEW;
      }
    } else {
      if (location.pathname.includes('/new')) return CrudMode.NEW;
      if (location.pathname.includes('/edit')) return CrudMode.EDIT;
      if (uuidValidate(location.pathname.split('/').pop()))
        return CrudMode.VIEW;
    }

    return CrudMode.LIST;
  }, [location.pathname, basePath]);
};
